import {
  // SessionStorageListenOptions,
  SessionStoragePlugin,
  SessionStorageRemoveAllOptions,
  SessionStorageRemoveOptions,
  SessionStorageUpdateOptions,
  SessionStorageGetKeyOptions,
  // SessionStorageListenListener,
} from '@absis/core-plugins/dist/types/types/core-plugins-types';

export const CBSessionStorage: SessionStoragePlugin = {
  // addListenerOnValueChanges: (
  //   options: SessionStorageListenOptions,
  //   listenerFunc: (data: SessionStorageListenListener) => void
  // ): Promise<void> => {
  //   const { keys } = options;

  //   window.addEventListener('storage', ({ key, newValue }) => {
  //     if (!key) return;
  //     if (keys.includes(key)) {
  //       listenerFunc({
  //         key: key,
  //         value: newValue,
  //       });
  //     }
  //   });

  //   return Promise.resolve();
  // },
  update: function (options: SessionStorageUpdateOptions): Promise<void> {
    if (!options) return Promise.reject('Options is required');

    const { key, value } = options;

    if (!key) return Promise.reject('Key is required');

    sessionStorage.setItem(key, value);
    return Promise.resolve();
  },

  getKey: function (
    options: SessionStorageGetKeyOptions
  ): Promise<string | null | undefined> {
    if (!options) return Promise.reject('Options is required');

    const { key } = options;

    if (!key) return Promise.reject('Key is required');
    const value = sessionStorage.getItem(key);
    return Promise.resolve(value);
  },

  deleteValueForKey: function (
    options: SessionStorageRemoveOptions
  ): Promise<void> {
    if (!options) return Promise.reject('Options is required');
    const { key } = options;
    if (!key) return Promise.reject('Key is required');
    sessionStorage.removeItem(key);
    return Promise.resolve();
  },
  deleteValuesForAllKeys: function (
    _options?: SessionStorageRemoveAllOptions
  ): Promise<void> {
    sessionStorage.clear();
    return Promise.resolve();
  },
};
